var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-row',{attrs:{"no-gutters":""}},[_c('family-activity-table',{attrs:{"items":_vm.tasks,"family":_vm.family,"custom-no-results":_vm.noDataText,"future":_vm.future},on:_vm._d({},[_vm.updatedEvent,_vm.loadData])})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }